//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import EventBus from "@/event-bus.js";
import { GET_PACIENTES_BY_MEDICO } from "@/graphql/queries/pacientes.js";
import { FIND_TIPOS_ENCUESTA } from "@/graphql/queries/encuestas.js";
import {
  CREAR_ENCUESTA,
  REGENERAR_CLAVES
} from "@/graphql/mutations/pacientes.js";
import { contextualHelp } from "@/utils/contextualHelp.js";

export default {
  name: "PacientesList",
  apollo: {
    pacientes: {
      query: GET_PACIENTES_BY_MEDICO,
      variables: {
        id: null
      },
      update(data) {
        if (data.findMedicoBy) {
          console.log(data.findMedicoBy);
          return data.findMedicoBy.pacientes;
        }
        return [];
      },
      skip() {
        return true;
      }
    },
    tiposEncuesta: {
      query: FIND_TIPOS_ENCUESTA,
      update(data) {
        return data.findTiposEncuesta;
      }
    }
  },
  mounted() {
    EventBus.$emit("page-loaded", { page: "PacientesList" });
    EventBus.$emit("dynamic-help", {
      help: contextualHelp["PacientesList"]
    });
    let user = this.$store.getters["auth/getUser"];
    this.$apollo.queries.pacientes.setVariables({
      id: +user.internal.id
    });
    this.$apollo.queries.pacientes.skip = false;
    this.$apollo.queries.pacientes.refetch();
  },
  data() {
    return {
      pacientes: [],
      tiposEncuesta: [],
      showTipoEncuesta: false,
      showRegenerarClaves: false,
      pacienteSelected: null,
      encuestaSelected: null,
      filter: "",
      currentSelected: null,
      columns: [
        {
          name: "dni",
          label: "DNI",
          align: "left",
          field: "dni"
        },
        {
          name: "nombre",
          label: "Nombre",
          align: "left",
          field: "nombre"
        },
        {
          name: "primer_apellido",
          label: "Primer Apellido",
          align: "left",
          field: "primer_apellido"
        },
        {
          name: "segundo_apellido",
          label: "Segundo Apellido",
          align: "left",
          field: "segundo_apellido",
          show: () => this.$q.screen.lt.md
        },
        {
          name: "options",
          label: ""
        }
      ]
    };
  },
  methods: {
    selectTipoEncuesta(paciente) {
      this.pacienteSelected = paciente;
      this.showTipoEncuesta = true;
    },
    fShowRegenerarClaves(paciente) {
      this.pacienteSelected = paciente;
      this.showRegenerarClaves = true;
    },
    async enviarEncuesta() {
      this.$q.loading.show({
        message: "Enviando encuesta..."
      });
      try {
        let user = this.$store.getters["auth/getUser"];
        await this.$apollo.mutate({
          mutation: CREAR_ENCUESTA,
          variables: {
            id_tipo_encuesta: this.encuestaSelected.id,
            id_medico: user.internal.id,
            id_paciente: this.pacienteSelected.id
          }
        });
        this.$q.notify({
          position: "top-right",
          message: "Encuesta enviada correctamente",
          color: "positive"
        });
      } catch (e) {
        console.log(e.message);
        this.$q.notify({
          position: "top-right",
          message: e.message,
          color: "negative"
        });
      } finally {
        this.$q.loading.hide();
      }
    },
    async regenerarClaves() {
      this.$q.loading.show({
        message: "Regenerando claves..."
      });
      try {
        let res = await this.$apollo.mutate({
          mutation: REGENERAR_CLAVES,
          variables: {
            id_paciente: this.pacienteSelected.id
          }
        });
        this.$q.notify({
          position: "top-right",
          message: "Claves generadas correctamente",
          color: "positive"
        });
        const downloadLink = document.createElement("a");
        const fileName = `${this.uuidv4()}.pdf`;
        downloadLink.href = res.data.regenerarCredenciales.file;
        downloadLink.download = fileName;
        downloadLink.click();
      } catch (e) {
        console.log(e.message);
        this.$q.notify({
          position: "top-right",
          message: e.message,
          color: "negative"
        });
      } finally {
        this.$q.loading.hide();
      }
    },
    uuidv4() {
      return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function(
        c
      ) {
        var r = (Math.random() * 16) | 0,
          v = c == "x" ? r : (r & 0x3) | 0x8;
        return v.toString(16);
      });
    },
    showBottomSheet(evt, row) {
      if (this.$q.screen.lt.md) {
        this.$q
          .bottomSheet({
            message: "Seleccione una acción: ",
            grid: false,
            actions: [
              {
                label: "Regenerar claves",
                icon: "vpn_key",
                id: "claves",
                classes: "custom-color-sheet"
              },
              {
                label: "Enviar encuesta",
                icon: "ballot",
                id: "encuesta",
                classes: "custom-color-sheet"
              },
              {
                label: "Mostrar histórico",
                icon: "date_range",
                id: "historico",
                classes: "custom-color-sheet"
              }
            ]
          })
          .onOk(action => {
            switch (action.id) {
              case "claves":
                this.fShowRegenerarClaves(row);
                break;
              case "encuesta":
                this.selectTipoEncuesta(row);
                break;
              case "historico":
                this.$router.push({
                  path: `/pacientes/${row.cognito_id}/historico`
                });
                break;
            }
          });
      }
    }
  }
};
